import { useState, useEffect } from 'react'
import { truthy } from '@/helpers/truthy'
import { useProduct } from '@/hooks/useProduct/index'
import { TurnToProduct, getReviewPerSku } from '@/helpers/turnToApi'
import { getPDPSchemaShippingPrice } from './getSchmeaShippingPrice'

const getName = (str = '') => `${str}`?.split('~')?.[0] || ''
const ProductSchema: React.FC = () => {
  const {
    product,
    sku,
    isVintage,
    selectedVariant,
    inStock,
    digestedPrice: { rawSalePrice },
    warrantyVariant,
  } = useProduct()
  const [review, setReview] = useState<TurnToProduct>()

  useEffect(() => {
    getReviewPerSku(sku).then(setReview)
  }, [sku])
  const inProductGroupwithID = (
    [...(product?.category_info || [])].sort((a, b) => {
      if ((a?.path?.length || 0) < (b?.path?.length || 0)) {
        return -1
      }
      return (
        ((a?.path?.length || 0) > (b?.path?.length || 0))
          ? 1
          : 0
      )
    })?.[0]?.path
    || product?.brand_code
    || product?.sku
    || sku
  )
  return (
    <script
      id="productSchemaScript"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'http://www.schema.org',
          '@type': 'product',
          name: getName(product?.name),
          sku,
          gtin: selectedVariant?.upc,
          brand: (!!product?.brand && {
            '@type': 'Brand',
            name: getName(product?.brand),
          }) || undefined,
          image: selectedVariant?.images?.map(({ url_standard }) => url_standard),
          description: product?.meta_description,
          inProductGroupwithID,
          offers: {
            '@type': 'Offer',
            availability: `https://schema.org/${inStock ? 'InStock' : 'OutOfStock'}`,
            price: parseFloat(`${rawSalePrice}`).toFixed(2),
            priceCurrency: 'USD',
            itemCondition: `https://schema.org/${isVintage ? 'UsedCondition' : 'NewCondition'}`,
            shippingDetails: {
              '@type': 'OfferShippingDetails',
              shippingRate: {
                '@type': 'MonetaryAmount',
                value: getPDPSchemaShippingPrice({
                  price: rawSalePrice,
                  isEntryway: truthy(warrantyVariant?.is_entryway),
                  iswhiteGlove: truthy(warrantyVariant?.is_white_glove),
                }),
                currency: 'USD',
              },
              shippingDestination: {
                '@type': 'DefinedRegion',
                addressCountry: 'US',
              },
              deliveryTime: {
                '@type': 'ShippingDeliveryTime',
                handlingTime: {
                  '@type': 'QuantitativeValue',
                  unitCode: 'DAY',
                  minValue: '0',
                  maxValue: '1',
                },
                transitTime: {
                  '@type': 'QuantitativeValue',
                  unitCode: 'DAY',
                  minValue: `${warrantyVariant?.estimated_min_delivery_days || 1}`,
                  maxValue: `${warrantyVariant?.estimated_max_delivery_days || 5}`,
                },
              },
            },
          },
          aggregateRating: review?.averageRating ? {
            '@type': 'AggregateRating',
            ratingValue: `${review?.averageRating || 0}`,
            reviewCount: `${review?.reviews || 0}`,
          } : undefined,
        }, undefined, 2),
      }}
    />
  )
}

export default ProductSchema
